import clsx from 'clsx';

import ContainerSection from '../container-section';
import VideoButton from '../video-button';

export interface TestimonialProps {
  imgOnRight?: boolean;
  imgSrc: string;
  name: string;
  position: string;
  testimonial: string;
  videoId: string;
  shouldShowVideo?: boolean;
  alt?: string;
  TestimonialComponent?: keyof React.JSX.IntrinsicElements;
}

const Testimonial: React.FC<TestimonialProps> = ({
  imgOnRight = false,
  imgSrc,
  name,
  position,
  testimonial,
  alt,
  videoId,
  shouldShowVideo = true,
  TestimonialComponent = 'p',
}) => (
  <div
    className={clsx('flex flex-col items-center gap-4 md:flex-row md:gap-14', {
      'md:flex-row-reverse': imgOnRight,
    })}>
    <div className='shrink-0'>
      <VideoButton alt={alt} imgSrc={imgSrc} videoId={videoId} circle shouldShowVideo={shouldShowVideo} />
    </div>

    <div className='text-default text-center md:text-left'>
      <TestimonialComponent className='mb-4 md:text-lg'>{testimonial}</TestimonialComponent>
      <p className='text-sm font-semibold md:text-xl'>{name}</p>
      <p className='text-xs md:text-sm'>{position}</p>
    </div>
  </div>
);

export const TestimonialSection: React.FC<TestimonialProps> = ({ ...props }) => (
  <section data-testid={`testimonial-${props.name}`} className='bg-primary-100 pt-4 pb-8 md:py-12'>
    <ContainerSection>
      <Testimonial {...props} />
    </ContainerSection>
  </section>
);

export default Testimonial;
